import React from "react";
import "../components/CWSelect.scss";
import Select from "react-dropdown-select";
import { InputProperty } from "../interfaces/generalInterface";

interface ISelectLabel extends InputProperty {
  options: any;
  dropdownGap?: number;
  values?: any;
  dropdownPosition: any;
  onChange?: (value: any) => void;
  searchable?: boolean;
  multi: boolean;
  disabled?: boolean;
}

const CWSelect = (props: ISelectLabel) => {
  const onChange = (e: any) => {
    if (props.onChange) props.onChange(e);
  };

  return (
    <div className="form-group cw-select">
      <div className={"custom-select-wrap" + " " + props.className}>
        <div className="label-wrap">
          <label>
            {props.label}
            {props.isMandatory && <span className="mandatory">*</span>}
          </label>
          <span>{props.help}</span>
        </div>
        <Select
          className={props.errorMessage && props.errorMessage !== "" ? "cutom-select error" : props.values && props.values[0] !== "" ? "cutom-select active" : "cutom-select"}
          placeholder={props.placeholder}
          options={props.options}
          dropdownGap={-3}
          values={props.values}
          dropdownPosition={props.dropdownPosition}
          onChange={onChange}
          searchable={props.searchable}
          backspaceDelete={false}
          multi={props.multi}
          disabled={props.disabled}
        />
        {props.errorMessage && props.errorMessage !== "" && <span className="error-msg">{props.errorMessage}</span>}
      </div>
    </div>
  );
};

CWSelect.defaultProps = {
  multi: false,
  disabled: false,
};
export default CWSelect;
